//AD role based auth is now obsolete. Roles & permissions are now determined by
//the api, and returned in /myaccount/info response, accessed via useUser(), and checked in SideNavigationMenu
export const ActiveDirectoryRoles = {
    Dnsp: "fa8a6352-3222-4ec4-b076-262c31f8807e",
    Engineering: "7df43390-e24c-405f-a70a-9b36f39ff4ad",
    Jemena: "bf71d9f0-bfea-4bf7-a802-85d78a7aeac1",
    RedEnergy: "043871ad-e17d-4699-981f-8e6af8927ec8",
    AusNet: "191c69b5-48cd-4920-997c-cef421666625",
};
